// extracted by mini-css-extract-plugin
export default {"clickable":"Market_clickable__5vKSO","mineralBadge":"Market_mineralBadge__kz9Cx","mineralBadgeCell":"Market_mineralBadgeCell__c3g+W"};